<style>
    .blockUI.blockMsg {
        top: 50% !important;
        left: 50% !important;
        -webkit-transform: translate(-50%, -50%) !important;
        transform: translate(-50%, -50%) !important;
        width: 100px !important;
        height: 100px !important;
        border: none !important;
        border-radius: 50% !important;
        z-index: 100000000 !important;
    }
    
    .imageRotateHorizontal {
        -moz-animation: spinHorizontal 1.5s infinite linear;
        -o-animation: spinHorizontal 1.5s infinite linear;
        -webkit-animation: spinHorizontal 1.5s infinite linear;
        animation: spinHorizontal 1.5s infinite linear;
    }
    
    @keyframes spinHorizontal {
        0% {
            transform: rotateY(0deg);
        }
        100% {
            transform: rotateY(360deg);
        }
    }
</style>
<div *ngIf="showLoading">
    <div class="blockUI"></div>
    <div class="blockUI blockOverlay" style="z-index: 1052; border: none; margin: 0px; padding: 0px; width: 100%; height: 100%; top: 0px; left: 0px; background-color: rgb(0, 0, 0); opacity: 0.6; cursor: wait; position: fixed;"></div>
    <div class="blockUI blockMsg blockPage" style="z-index: 1066; position: fixed; padding: 0px; margin: 0px; width: 30%; top: 40%; left: 35%; text-align: center; color: rgb(0, 0, 0); border: 3px solid rgb(170, 170, 170); cursor: wait;">
        <h1><img class="imageRotateHorizontal spinHorizontal" src="dist/DPM/assets/img/LOGO.png" style="width: 50px;display: block;margin: 0px auto;padding-top:5px"><span style="font-size:12px; color: #ebe9e9; margin: 8px 0 0 13px;display: block;"> loading...</span></h1>
    </div>
</div>